import React from 'react'
import { CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'
import { useAppDispatch } from '@SonarCX/hooks/redux'
import { useDrag } from 'react-dnd'

import { EmailWrapperType, removeEmail } from '@SonarCX/slices/extensionAPI'

import DragIcon from '@SonarCX/components/icons/DragIcon'

import { useAreYouSure } from '@SonarCX/providers/AreYouSureProvider'
import useStyles from './styles'

export const EMAIL_DRAG_TYPE = 'EMAIL_DRAG_TYPE'

type EmailProps = {
  wrapped: EmailWrapperType
}

const Email: React.FC<EmailProps> = ({ wrapped: { id, email, file } }) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()

  const { setTitle, setSubtext, setReason, setV2, setAction } = useAreYouSure()

  const [{ opacity }, dragRef, previewRef] = useDrag({
    item: { type: EMAIL_DRAG_TYPE, id },
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.4 : 1
    })
  })

  const classes = useStyles()

  const onDelete = React.useCallback(() => {
    setTitle('Remove email?')
    setSubtext('')
    setReason('Are you sure you want to remove this email?')
    setV2(true)
    setAction(() => {
      dispatch(removeEmail(id))
    })
  }, [setTitle, setSubtext, setReason, setV2, setAction, dispatch, id])

  return (
    <div ref={previewRef} className={classes.root} style={{ opacity }}>
      <div ref={dragRef} className={classes.dragHandle}>
        <DragIcon />
      </div>

      <div className={classes.email}>
        <div className={classes.subject}>{email.subject}</div>

        <div className={classes.info}>
          <div className={classes.from}>{email.sender}</div>

          <div className={classes.date}>{email.receivedTime}</div>
        </div>
      </div>

      <div className={classes.delete}>
        <CloseCircle
          size={theme.size.base}
          onClick={onDelete}
          className={classes.deleteButton}
        />
      </div>
    </div>
  )
}

export default Email
